import {
  Box,
  Paper,
  Title,
  createStyles,
  Center,
  Loader,
  Grid,
  Text,
  Select,
  UnstyledButton,
  Table,
  Badge,
  Indicator,
  Avatar,
} from "@mantine/core";
import { Pagination } from "@mantine/core";
import Buttonfilter from "../../assets/img/Icon Button.svg";
import finalizedTask from "../../assets/img/finalizedTask.svg";
import { useEffect, useState } from "react";
import { QuestDetails } from "./Details";
import SimpleLineChart from "../Dashboard/Last";
import searchIcon from "../../assets/img/searchIcon.svg";
import rejectedSvg from "../../assets/img/rejected.svg";
import pendingSvg from "../../assets/img/pending.svg";
import completedSvg from "../../assets/img/completd.svg";
// import { capitalizeFirstLetter } from "../Audit-Logs/AuditService";
import { keyframes } from "@emotion/react";
import AnimatedWaves from "../../components/AnimatedWaves";
import { useMedplum } from "@medplum/react";
import {
  addPatientNames,
  countStatus,
  countStatusByPatient,
  getQuestionnaireResource,
  patientResource,
  patientSearch,
  renderStatusBadges,
  reorderQuestionnaireIds,
} from "./Service";
import { calculateAge, formatDateTime } from "@medplum/core";
import { SelectItem } from "../ClinicalNotes/clinicalNotesService";
import { circularPlatformLogo } from "../../utils";
import { getPatientName } from "../Eligibility/EligibiltyService";
import { useLocation, useNavigate } from "react-router-dom";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  createVideoAppointment: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  infoCard: {
    borderRadius: "8px",
    minHeight: "145px",
    flexBasis: "100%",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "15px",
    paddingTop: "15px",
    maxHeight: "145px",
  },
  searchBar: {
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    paddingTop: "24px",
    paddingBottom: "16px",
    alignItems: "center",
  },
  table: {
    marginTop: "30px",
  },
  thead: {
    backgroundColor: "#BEDEF8",
    borderRadius: 4,
  },
  redDot: {
    width: "12px",
    height: "12px",
    backgroundColor: "red",
    borderRadius: "50%",
    display: "inline-block",
    animation: "$fade 1.5s infinite",
  },

  "@keyframes fade": {
    "0%": { opacity: 0 },
    "50%": { opacity: 1 },
    "100%": { opacity: 0 },
  },
}));

export const Questionnaire = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const location = useLocation();

  const [resource, setResource] = useState<any>([]);
  const [loading, setloading] = useState<boolean>(false);
  const [searchQuery, setSearcQuery] = useState<string>("");
  const [selctedPatient, setselectedPatient] = useState<string>();
  const [patientList, setPatientList] = useState<any>([]);
  const [searchPatientDta, setSearchPatientData] = useState<any>([]);
  const [completed, setcompleted] = useState<any>("--");
  const [rejected, setRejected] = useState<any>("--");
  const [inprogress, setprogress] = useState<any>("--");
  const [ispatientfetched, setispatientfetched] = useState<any>(false);
  const [filterIds, setFilterIds] = useState<any>([]);
  const [componentHeading, SetcomponenetHeading] = useState<any>();
  const navigate = useNavigate();
      const { ids } = location.state;


  const cardData = [
    {
      id: 1,
      image: completedSvg,
      title: "Completed",
      count: completed,
      chartData: [1, 2, 3, 4, 5, 6.7, 8],
      color: "green",
    },
    {
      id: 2,
      image: pendingSvg,
      title: "In Progress",
      count: inprogress,
      chartData: [1, 2, 3, 4, 5, 6.7, 8],
      color: "yellow",
    },
    {
      id: 3,
      image: rejectedSvg,
      title: "Not Answered",
      count: rejected,
      chartData: [1, 2, 3, 4, 5, 6.7, 8],
      src: completedSvg,
      color: "red",
    },
  ];

  useEffect(() => {
    Response(false);
    idsFetched();
    count("completed");
    count("in-progress");
    count("stopped");
  }, []);
  useEffect(() => {
    if (selctedPatient) {
      Response(true);
    }
  }, [selctedPatient]);

  const Response = (search?: boolean) => {
    if (search) {
      const questRes = getQuestionnaireResource(medplum, 20, 1, [
        `Patient/${selctedPatient}`,
      ]).then((responseForquest) => {
        const statusForPatients = responseForquest;
       if (statusForPatients.length === 0) {
         const data = {
          patientId:patientList[0]?.value,
           name: patientList[0]?.label,
           age: calculateAge(patientList[0]?.dob),
         };

       


         setResource([data]); // Set the mapped data to state
       } else {
         const newData = addPatientNames(searchPatientDta, statusForPatients);
         // const sortedResource = reorderQuestionnaireIds(newData, filterIds);

         setResource(newData);
       }
      });
    } else if (!search) {
      setloading(true);

      const fetchData = patientResource(medplum, 500, 1).then((res) => {
        const patient = res;
        const idArray = res.map((item) => `Patient/${item.id}`);

        if (idArray.length > 0) {
          const questRes = getQuestionnaireResource(
            medplum,
            500,
            1,
            idArray
          ).then((responseForquest) => {

            const statusForPatients = responseForquest;
            const newData = addPatientNames(patient, statusForPatients);
          
            
            
          reorderQuestionnaireIds(newData, ids).then((res) => {
           
            setResource(res);
          });


            // setResource(sortedResource);
            
            setloading(false);
          });
        }
        setloading(false);
      });
    }
  };
  useEffect(() => {
    searchPatient();
  }, [searchQuery]);

  const count = (status: any) => {
    const count = countStatus(medplum, status).then((res: any) => {
      if (status === "completed") {
        setcompleted(res.bundle.total);
      } else if (status === "in-progress") {
        setprogress(res.bundle.total);
      } else if (status === "stopped") {
        setRejected(res.bundle.total);
      }
    });
  };

  const searchPatient = () => {
    setispatientfetched(true);
    const searchPatient = patientSearch(medplum, searchQuery).then((res) => {
      setSearchPatientData(res);

      const patientData = res.map((patient: any) => {
        const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
          (coding: any) => coding.system?.includes("cerner")
        );
        const containsAthena = patient?.identifier?.some(
          (item: any) => item.system && item.system.includes("athena")
        );
        let ehrtype = "";
        if (
          patient?.identifier?.find(
            (id:any) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
          )
        ) {
          ehrtype = "EPIC";
        } else if (containsCerner) {
          ehrtype = "Cerner";
        } else if (containsAthena) {
          ehrtype = "Athena Health";
        } else {
          ehrtype = "Others";
        }
        let EHRIcon;
        switch (ehrtype) {
          case "EPIC":
            EHRIcon = (
              <img
                src={circularPlatformLogo["epic"]}
                style={{
                  marginRight: "10px",
                  width: "30px",
                }}
                alt="EPIC"
              />
            );
            break;
          case "Cerner":
            EHRIcon = (
              <img
                src={circularPlatformLogo["cerner"]}
                style={{
                  marginRight: "10px",
                  width: "30px",
                }}
                alt="Cerner"
              />
            );
            break;
          case "Athena Health":
            EHRIcon = (
              <img
                src={circularPlatformLogo["athenahealth"]}
                style={{
                  marginRight: "10px",
                  width: "30px",
                }}
                alt="Athena"
              />
            );
            break;
          default:
            EHRIcon = (
              <img
                src={circularPlatformLogo["others"]}
                style={{
                  marginRight: "10px",
                  width: "30px",
                }}
                alt="Others"
              />
            );
        }
        return {
          label: getPatientName(patient.name),
          value: patient.id,
          ehr: ehrtype,
          icon: EHRIcon,
          dob: patient.birthDate,
        };
      });
      
      setPatientList(patientData);
      setispatientfetched(false);
    });
  };

  const onSearchChange = (value: any) => {
    setSearcQuery(value);
  };
  const handleChange = (value: any) => {
    setselectedPatient(value);
  };

  const idsFetched = () => {
    const { ids } = location.state;
    const  {name } = location.state;
    SetcomponenetHeading(name);
   
    setFilterIds(ids);
  };
  return (
    <>
      <Paper className={classes.default}>
        <Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Title
                  sx={{
                    fontWeight: 700,
                    fontSize: "26px",
                    lineHeight: "36px",
                    color: "#262930",
                    marginBottom: "30px",
                  }}
                >
                  {componentHeading??"--"}
                </Title>
              </Box>
            </Box>

            {/* table */}
            <Box>
              {/* cards */}
              <Grid>
                {cardData.map((card) => (
                  <Grid.Col span={4} key={card.id}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "24px",
                        borderRadius: "8px",
                        border: "1px solid #EDEDED",
                        gap: "10px",
                        height: "156px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "24px",
                        }}
                      >
                        <img src={card.image} alt={card.title} />
                        <Text
                          color="#474E5B"
                          align="center"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {card.title}
                        </Text>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text
                          fw={700}
                          fs={"48px"}
                          color="#474E5B"
                          align="end"
                          sx={{
                            lineHeight: "40px",
                            fontWeight: 700,
                            fontSize: "48px",
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          {card.count}
                        </Text>
                        <Box
                          sx={{
                            width: "130px",
                            height: "52px",
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <SimpleLineChart
                            data={card.chartData}
                            color={card.color}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Grid.Col>
                ))}
              </Grid>
            </Box>
            <Box className={classes.searchBar}>
              <Box sx={{ width: "50%", maxWidth: "438px" }}>
                <Select
                  // label="Select patient"
                  icon={<img src={searchIcon} />}
                  placeholder="Search by keyword"
                  required={true}
                  data={patientList}
                  rightSection={ispatientfetched ? <Loader size={"sm"} /> : ""}
                  size="lg"
                  radius="md"
                  clearable={true}
                  onChange={handleChange}
                  sx={{
                    ".mantine-Select-itemsWrapper": {
                      paddingRight: "10px",
                    },
                  }}
                  searchable
                  onSearchChange={onSearchChange}
                  searchValue={searchQuery}
                  itemComponent={SelectItem}
                />
              </Box>

              <Box>
                <UnstyledButton>
                  <Box>
                    <img src={Buttonfilter} />
                  </Box>
                </UnstyledButton>
              </Box>
            </Box>
            <Box>
              <Box sx={{ paddingBottom: "16px" }}>
                {loading ? (
                  <Center pt={70}>
                    <Loader />
                  </Center>
                ) : (
                  <Box>
                    <Table
                      className={classes.table}
                      horizontalSpacing="md"
                      verticalSpacing="md"
                    >
                      <thead className={classes.thead}>
                        <tr>
                          {[
                            "Name",
                            "Age",
                            "Last Updated",
                            "Questionnaire Status",
                          ].map((val) => (
                            <th key={val}>{val}</th>
                          ))}
                        </tr>
                      </thead>{" "}
                      {resource?.map((data: any) => (
                        <tbody
                          onClick={() => {
                            navigate(`details/${data?.patientId}`, {
                              state: { filterIds, componentHeading },
                            });
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <tr key={data?.id}>
                            <td>{data?.name}</td>
                            <td>{data?.age?.years}</td>
                            <td>{formatDateTime(data?.lastUpdated)??"--"}</td>

                            <td>{renderStatusBadges(data?.status)??"--"}</td>
                          </tr>
                        </tbody>
                      ))}
                    </Table>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </>
  );
};
